import React, { useRef } from 'react';
import { ChevronDown } from 'lucide-react';

const ColorSelect = ({
  disabled = false,
  label,
  name,
  value = '#7D48C7',
  onChange,
  required,
  withText = false,
  dotSize = '12px',
  dotRadius = '4px',
}) => {
  const inputRef = useRef(null);

  const openPicker = (e) => {
    if (disabled) return;
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (inputRef.current) inputRef.current.click();
  };

  const handleColorChange = (e) => {
    const newValue = e && e.target ? e.target.value : value;

    if (onChange) {
      onChange({ target: { name, value: newValue } });
    }
  };

  const currentColor = value || '#7D48C7';

  return (
    <div className="flex flex-col gap-1 relative">
      {label && (
        <label htmlFor={name} className="text-lg text-blueDarker font-normal">
          {label}
          {required && <span className="ml-1.5">*</span>}
        </label>
      )}

      <div className="relative">
        <select
          id={name}
          name={name}
          value={value}
          disabled={disabled}
          required={required}
          onMouseDown={openPicker}
          onClick={openPicker}
          onKeyDown={(e) => {
            if (disabled) return;
            if (e.key === 'Enter' || e.key === ' ') openPicker(e);
          }}
          className={[
            'appearance-none w-full border border-bluePale rounded-xl px-3 py-3 text-base bg-white pr-10 cursor-pointer',
            'text-transparent caret-transparent select-none',
            'focus:text-transparent',
          ].join(' ')}
        >
          <option value={currentColor}>.</option>
        </select>

        <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center gap-2">
          <span
            className="block shrink-0"
            style={{ backgroundColor: currentColor, borderRadius: dotRadius, width: dotSize, height: dotSize }}
          />
          {withText && <span className="text-base text-gray-800 uppercase tracking-wide">{currentColor}</span>}
        </div>

        <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
          <ChevronDown size={18} className="text-blueSteel" strokeWidth={1.5} />
        </div>

        <input
          ref={inputRef}
          type="color"
          name={name}
          id={`${name}__picker`}
          value={currentColor}
          disabled={disabled}
          onChange={handleColorChange}
          className="absolute opacity-0 pointer-events-none w-0 h-0"
        />
      </div>
    </div>
  );
};

export default ColorSelect;
